exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.page-container[data-v-4292f7b8] {\n  min-height: 100vh;\n}\n.page-content[data-v-4292f7b8] {\n  min-width: 0 !important;\n}\n", "", {"version":3,"sources":["/var/www/dev.b1g1.com/src/components/BusinessPanel.vue"],"names":[],"mappings":";AAqCA;EACE,kBAAkB;CACnB;AAED;EACE,wBAAwB;CACzB","file":"BusinessPanel.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.page-container {\n  min-height: 100vh;\n}\n\n.page-content {\n  min-width: 0 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4292f7b8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BusinessPanel.vue
// module id = 5FlL
// module chunks = 149